import React, { useEffect, useState } from "react";
import CrmInputField from "../../component/CrmUI/CrmProfileUI/CrmInputFields";
import CrmSelectField from "../../component/CrmUI/CrmProfileUI/CrmSelectField";
import CrmTextAreaField from "../../component/CrmUI/CrmProfileUI/CrmTextAreaField";
import { CrmUseProfile } from "../../features/Crm/CrmProfile/CrmUseProfile";
import { useCrm } from "../../context/CrmContext";
import ImageUploader from "../../component/InventoryUI/ImageUploader";
import { useSnackbar } from "../../context/SnackBarContext";
import { apiUrl, getAuthToken, imageBaseUrl } from "../../utils/utils";
import axios from "axios";

const CrmProfile = () => {
    const { states } = CrmUseProfile();
    const { user, setUser } = useCrm();
    const { showSuccess, showError } = useSnackbar();

    // Local form state
    const [formData, setFormData] = useState({
        name: "",
        telephone: "",
        email: "",
        role: "",
        companyName: "",
        gst: "",
        address: "",
        businessDescription: "",
        state: "",
        businessType: "",
        businessCategory: "",
        signature: "",
        profile_image: "",
        error: ""
    });

    // Map user → formData whenever user changes
    useEffect(() => {
        if (user) {
            setFormData({
                name: user?.name || "",
                telephone: user?.telephone || "",
                email: user?.email || "",
                role: user?.role || "",
                companyName: user?.companyName || "",
                gst: user?.gst || "",
                address: user?.address || "",
                businessDescription: user?.businessDescription || "",
                state: user?.state || "",
                businessType: user?.businessType || "",
                businessCategory: user?.businessCategory || "",
                signature: imageBaseUrl + `images/${user?.signature}` || "",
                profile_image: imageBaseUrl + `images/${user?.profile_image}` || "",
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const updateState = (data) => {
        setFormData((prevState) => {
            const newState = { ...prevState, ...data };
            return newState;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation
        if (!formData.name?.trim()) return showError("Name is required");
        if (!formData.telephone?.trim()) return showError("Phone Number is required");
        if (!/^[0-9]{10}$/.test(formData.telephone)) return showError("Enter a valid 10-digit phone number");
        if (!formData.email?.trim()) return showError("Email is required");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) return showError("Enter a valid email address");
        if (!formData.role?.trim()) return showError("Role is required");
        if (!formData.companyName?.trim()) return showError("Business Name is required");
        if (!formData.gst?.trim()) return showError("GSTIN is required");
        if (!formData.address?.trim()) return showError("Business Address is required");
        if (!formData.state?.trim()) return showError("State is required");


        let getToken = getAuthToken()
        const payload = new FormData();

        // for (let key in formData) {
        //     payload.append(key, formData[key]);
        // }

        for (let key in formData) {
            let value = formData[key];

            // Special case for signature and profile_image
            if ((key === "signature" || key === "profile_image") && value) {
                if (typeof value === "string" && value.startsWith("http")) {
                    // Extract file name/id from URL
                    const parts = value.split("/");
                    const imageId = parts[parts.length - 1];
                    payload.append(key, imageId);
                } else {
                    // New file object or base64 string
                    payload.append(key, value);
                }
            } else {
                payload.append(key, value);
            }
        }
        axios.put(
            `${apiUrl}/crm/auth/update_profile/${user?._id}`, payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: getToken, // attach token
                },
            }
        )
            .then((res) => {
                console.log("data dekhooo", res)
                setUser(res.data.data);
                showSuccess("Profile updated successfully!");
            })
            .catch((error) => {
                console.error("Error updating profile:", error);
                showError("Something went wrong while updating profile");
            });
    };

    console.log("lnkljk ===>>", formData)

    return (
        <div className="min-h-screen p-8 bg-white">
            <h1 className="text-2xl font-bold text-black mb-6">Business Profile</h1>

            <div className="grid lg:grid-cols-2 grid-cols-1 gap-8">
                {/* LEFT SIDE FORM */}
                <form
                    onSubmit={handleSubmit}
                    className=" pr-2"
                >
                    {/* PERSONAL DETAIL */}
                    <h2 className="text-green-700 font-bold mb-2">PERSONAL DETAIL</h2>
                    <div className="grid lg:grid-cols-2 gap-4 grid-cols-1">
                        <CrmInputField label="Name *" name="name" value={formData.name} onChange={handleChange} />
                        <CrmInputField label="Phone Number *" name="telephone" value={formData.telephone} onChange={handleChange} />
                        <CrmInputField label="Email Id *" name="email" value={formData.email} onChange={handleChange} />
                        <CrmInputField label="Role *" name="role" value={formData.role} onChange={handleChange} />
                    </div>
                    {/* BUSINESS DETAIL */}
                    <h2 className="text-green-700 font-bold mb-2 mt-5">BUSINESS DETAIL</h2>
                    <div className="flex lg:flex-wrap flex-col  gap-4">
                        <CrmInputField label="Business Name *" name="companyName" value={formData.companyName} onChange={handleChange} />
                        <CrmInputField label="GSTIN *" name="gst" value={formData.gst} onChange={handleChange} />
                        <CrmTextAreaField label="Business Address *" name="address" placeholder="Address..." value={formData.address} onChange={handleChange} rows={3} />
                        <CrmTextAreaField label="Business Description" name="businessDescription" placeholder="Enter description..." value={formData.businessDescription} onChange={handleChange} rows={3} />
                        <CrmSelectField label="State *" name="state" value={formData.state} onChange={handleChange} options={states} />
                        <CrmInputField label="Business Type" name="businessType" value={formData.businessType} onChange={handleChange} />
                        <CrmInputField label="Business Category" name="businessCategory" value={formData.businessCategory} onChange={handleChange} />
                    </div>

                </form>

                {/* RIGHT SIDE PROFILE PHOTO */}
                <div className="flex flex-col mt-5">
                    <h2 className="text-green-700 font-bold uppercase">Business Logo</h2>
                    <ImageUploader
                        selectedImage={formData.profile_image}
                        setSelectedImage={(file) => updateState({ profile_image: file })}
                        error={formData.error}
                        setError={(err) => updateState({ error: err })}
                    />


                    {/* SIGNATURE */}
                    <div className="col-span-2 mt-4">
                        <h2 className="text-green-700 font-bold mb-2">SIGNATURE</h2>
                    </div>
                    <div className="col-span-2">
                        <label className="block text-sm font-medium">Signature or Stamp</label>
                        <ImageUploader
                            selectedImage={formData.signature}
                            setSelectedImage={(file) => updateState({ signature: file })}
                            error={formData.error}
                            setError={(err) => updateState({ error: err })}
                        />
                    </div>
                </div>
            </div>

            {/* BUTTONS */}
            <div className="col-span-2 flex justify-end mt-6 space-x-4">
                {/* <button
                    type="button"
                    className="px-6 py-2 bg-green-900 text-white rounded"
                >
                    Cancel
                </button> */}
                <button
                    className="px-6 py-2 bg-green-700 text-white rounded"
                    onClick={handleSubmit}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default CrmProfile;
